<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Fetch news and events data from center
const { data: newsAndEventsData, isPlaceholderData: newsAndEventsPlaceholder, suspense: newsAndEventsSuspense } = useFetchEventsAndNews(centerRoute.value)

// Initial fetch (consumer) coupons
const bearerToken = useState('state_bearerToken')
const oid = useState('state_userOid')

const { data: couponsData, suspense: couponsSuspense, isPlaceholderData: couponsPlaceholder } = useFetchCoupons({
    centerRoute: centerRoute.value,
    bearerToken,
    oid
})

// Prefetch data on the server side
onServerPrefetch(async () => {
    await newsAndEventsSuspense() // Wait for the query to finish fetching
    await couponsSuspense() // Wait for the query to finish fetching
})

// Compute carousel config
const carouselConfig = computed(() => {
    return {
        items: newsAndEventsData.value,
        placeholder: newsAndEventsPlaceholder.value,
        type: 'news-and-events'
    }
})

// Compute coupon list config
const couponListConfig = computed(() => {
    return {
        placeholder: couponsPlaceholder.value,
        items: couponsData.value,
        couponLink: 'centerUid-coupons',
        tracking: 'center'
    }
})
</script>

<template>
    <section class="center-details">
        <header class="center-details-center-logo-header">
            <CenterLogoHeader />
        </header>

        <div class="center-details-coupons-list-container">
            <ContentHeadline :content-headline-config="{ title: staticKeys?.coupon_overview_headline_web }" />
            <CouponList :coupon-list-config="couponListConfig" />
        </div>

        <div class="center-details-carousel-teaser-container">
            <ContentHeadline :content-headline-config="{ title: staticKeys?.center_teaser_news_events_headline }" />
            <CarouselTeaser :carousel-config="carouselConfig" />
        </div>
    </section>
</template>

<style lang="scss">
.center-details {
    @include page-grid;
}

.center-details-center-logo-header {
    grid-column: 2/-2;
    margin-block-start: 40px; // mobile: breathing room to the teal band above (redesign CN-12074)

    @include bp(large1) {
        margin-block-start: 80px;
    }

    a {
        pointer-events: none;
    }
}

.center-details-coupons-list-container {
    grid-column: 2/-2;
}

.center-details-carousel-teaser-container {
    grid-column: 1/-1;

    @include bp(large1) {
        grid-column: 2/-2;
    }

    > h2 {
        margin-inline: 4%;

        @include bp(large1) {
            margin-inline: 0;
        }
    }
}
</style>
